import { alpha, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(2),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: alpha(theme.palette.secondary.light, 0.15),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: '1 1 100%',
  },
  chipsRoot: {
    display: 'flex',
    justifyContent: 'center',
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    '& > *': {
      margin: theme.spacing(0.5),
    },
  },
  editFilterChip: {
    marginLeft: theme.spacing(1),
  },
  addFilterButton: {
    marginLeft: theme.spacing(0.5),
  },
  searchRoot: {
    position: 'relative',
    width: '100%',
    '& .MuiSvgIcon-root': {
      position: 'absolute',
      left: 10,
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: 1,
      color: theme.palette.text.secondary,
      fontSize: 20,
    },
    '& .MuiInputBase-root': {
      width: '100%',
    },
    '& .MuiInputBase-input': {
      height: 36,
      borderRadius: 4,
      border: `1px solid ${theme.palette.borderColor.main}`,
      color: theme.palette.text.disabled,
      boxSizing: 'border-box',
      padding: '5px 15px 5px 35px',
      transition: 'all 0.3s ease',
      fontSize: 14,
      color: '#000',
      boxShadow: '0 0px 8px 0 rgb(0 0 0 / 8%)',
      '&::placeholder': {
        color: '#333',
      },
      '&:focus': {
        borderColor: theme.palette.primary.main,
      },
    },
  },
  filterList: {
    textAlign: 'right',
    '& li': {
      padding: '8px',
    },
  },
  innerFilterList: {
    border: '1px solid #cccccc',
    padding: '0',
    borderRadius: '4px',
    '& li': {
      padding: '4px',
    },
  },
  sortListItem: {
    '& input': {
      minHeight: '32px',
    },
  },
}));

export default useStyles;
